export function getStatusPaymentStyle(elem) {
      switch (elem.payment_status) {
            case 'paid':
                  return { label_top: 'Paid', desc: 'No action needed', icon: { color: 'td-green-icon', svg: 'cash' } }
            case 'partially_paid':
                  return { label_top: 'Partially paid', desc: 'Payment needed', icon: { color: 'td-orange-icon', svg: 'cash' } }
            case 'credited':
                  return { label_top: 'Credited', desc: 'Outstanding credit', icon: { color: 'td-orange-icon', svg: 'cash' } }
            default:
                  return { label_top: 'Unpaid', desc: 'Payment needed', icon: { color: 'td-orange-icon', svg: 'cash' } }
      }
}
